export const SET_MAIN_GUEST_INFO = 'SET_MAIN_GUEST_INFO';
export const RESET_DEFAULT_CLIENT_DATA = 'RESET_DEFAULT_CLIENT_DATA';
